import React from 'react';
import { Col, Card, CardGroup, Row } from 'react-bootstrap';
import { searchWord } from '../../helpers/common';

const CrewEqGroupList = ({ equipmentGroupList, isFetching, selectedList, isEditMode,
    currentCrewId, workPlanEqGroupList, onSelect, searchText, onChangeSearchText, unit, settings, children }) => {

    const eqWiseWorkPlan = {};
    workPlanEqGroupList && workPlanEqGroupList.forEach(item => { eqWiseWorkPlan[item.equipment_group_uuid] = item; });

    let filterEquipmentGroupList = equipmentGroupList;
    if (searchText.trim().length > 0)
        filterEquipmentGroupList = equipmentGroupList.filter(e => searchWord(e.equipment_group_name, searchText));

    return (
        <div className="card-eg-container m-2 px-4" >
            <Row className="pb-2">
                <div className="input-group">
                    <input className="form-control" type="input" value={searchText} onChange={onChangeSearchText}
                        autoComplete="off" placeholder="Search" />
                </div>
            </Row>
            <Row className="m-0">
                <h6>Selected equipment groups {equipmentGroupList.length > 0 && `(${selectedList.length}/${equipmentGroupList.length})`}</h6>
            </Row>
            {isFetching && <Row>Loading...</Row>}
            {!isFetching && filterEquipmentGroupList.length === 0 && <Row>No equipment group found</Row>}
            <Row className="row-msg">{children}</Row>
            <Row>
                <CardGroup className={isEditMode && "edit-mode"}>
                    {filterEquipmentGroupList.map((item, i) => {
                        const crewId = item.crew.crew_uuid;
                        const eqGroupId = item.equipment_group_uuid;
                        const isSetAcres = item.implement.equipment_uuid && (crewId === currentCrewId || item.associated_status === 0);

                        let acresPerDay = null;
                        if (isSetAcres) acresPerDay = eqWiseWorkPlan.hasOwnProperty(eqGroupId) ? unit.toRoundOfArea(eqWiseWorkPlan[eqGroupId].acres_per_day) : 0;

                        return (<EqGroupCard key={i} {...item} {...{ acresPerDay, onSelect, settings }}
                            selected={selectedList.indexOf(item.equipment_group_uuid) >= 0}
                            disabled={crewId !== currentCrewId && item.associated_status === 1} />);
                    })}
                </CardGroup>
            </Row>
        </div >);
}

const EqGroupCard = (props) => {
    return (<Card className={props.selected ? "active" : ""}>
        <Row className="m-0">
            <Col lg={3} md={3} sm={3} className="img-block">
                <img alt="" src={props.img.sm} />
            </Col>
            <Col lg={9} md={9} sm={9}>
                <Card.Body>
                    <Row>
                        <Col lg={6} md={6} sm={6}>
                            <div className="item-header">{props.equipment_group_name}</div>
                            <div className="item-text-xs"><i className="fa fa-user" /> {props.operator.name}</div>
                            <div className="item-text-md">{props.crew.name}</div>
                        </Col>
                        <Col lg={4} md={4} sm={4} className="m-auto text-center">
                            {props.acresPerDay !== null && <div>
                                <div className="item-text-lg">{props.acresPerDay}</div>
                                <small>{props.settings.areaShortName}/day</small>
                            </div>}
                        </Col>
                        <Col lg={2} md={2} sm={2} className="m-auto text-center">
                            <EqGroupCheckBox disabled={props.disabled} checked={props.selected}
                                onSelect={props.onSelect} eqGroupId={props.equipment_group_uuid} />
                        </Col>
                    </Row>
                </Card.Body>
            </Col>
        </Row>
    </Card>);
}

const EqGroupCheckBox = ({ disabled, eqGroupId, checked, onSelect }) => {
    if (disabled) return (<input type="checkbox" disabled={true} defaultChecked={true} />);
    else return (<input type="checkbox" defaultChecked={checked} onClick={onSelect.bind(this, eqGroupId)} />);
}

export default CrewEqGroupList;